import { render } from "./TaxonItem.vue?vue&type=template&id=1d0ab523&scoped=true"
import script from "./TaxonItem.vue?vue&type=script&lang=js"
export * from "./TaxonItem.vue?vue&type=script&lang=js"

import "./TaxonItem.vue?vue&type=style&index=0&id=1d0ab523&scoped=true&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-moose_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0ab523"]])

export default __exports__